var moment = require('moment');
var _ = require('underscore');

Octopus.ReleaseMatrix = function ReleaseMatrix(element, taskStatusRenderer, octoUtil) {
    // Draws the release matrix table used on either the dashboard, or project overview.
    // Usage:
    //
    //    var matrix = new ReleaseMatrix(element, taskStatusRenderer, octoUtil);
    //    // configure properties (see below)
    //

    var matrix = this;
    matrix.rows = [];                       // Array of whatever will be rows of data (projects for the dashboard, releases for project overview)
    matrix.environments = [];               // Array of Octopus Environment resources
    matrix.heading = "";                    // Heading to show in the top left corner
    matrix.items = {};                      // Dictionary of items to show
    matrix.keyFromPair = function () {};    // Function that takes a column and row, and returns a unique string key from it
    matrix.environmentsById = {};
    matrix.promotions = {};
    matrix.previousDeployments = {};
    matrix.projectEnvironmentTenantIndex = {};
    matrix.environmentTenantIndex = {};
    matrix.promoteTo = [];

    matrix.renderEmptyRow = function (html) { };
    matrix.renderEmptyCell = function(key, html) { };
    matrix.renderGroupDeployButton = function (env, html) { };

    var previousItems = {};

    matrix.render = function() {
        if (hasGreaterThanTenEnvironments()) {
            applySparseboard();
        }
        fullRender();
        previousItems = matrix.items;
    };

    matrix.update = function() {
        if (hasGreaterThanTenEnvironments()) {
            applySparseboard();
        }
        partialRender();
        previousItems = matrix.items;
    };

    var fullRender = function() {
        element.html(renderTable());
        taskStatusRenderer.bindPopovers($(".status", element));
        $("#dynamicallyGeneratedContent").empty();
    };

    var hasGreaterThanTenEnvironments = function() {

        var hasGreaterThanTenEnvironments = matrix.environments.length > 10;
        return hasGreaterThanTenEnvironments;

    };

    var applySparseboard = function() {

        var keys = _.keys(matrix.items);

        //For some reason this data is in different places depending on if its tenanted or not.
        var promotions = (matrix.promoteTo || []).map(function(p) { return p.Id });
        var progressions = _.map(matrix.progressions || {}, function(p) { return p.envId; });
        var promotableEnvironments = _.uniq(promotions.concat(progressions));

        // Filter Environments
        var newEnvironments = _.filter(matrix.environments, function (env) {
            return promotableEnvironments.indexOf(env.Id) !== -1 ||
                _.some(keys, function (key) {
                    return key.indexOf(env.Id + "__") >= 0;
                });
        });

        matrix.environments = newEnvironments;
    };

    var renderTable = function() {
        var html = [];
        html.push('<div class="margin-bottom-30">');
        html.push(  '<div class="matrix-container ">');
        html.push(    '<div class="overflow-scroll">');
        html.push(      '<table class="matrix">');
        renderHeadings(html);
        html.push(        '<tbody>');
        renderRows(html);
        html.push(        '</tbody>');
        html.push(      '</table>');
        html.push(    '</div>');
        html.push(  '</div>');
        html.push('</div>');
        return html.join('');
    };

    var renderHeadings = function(html) {
        html.push('<thead>');
        html.push(  '<tr>');
        html.push(    '<th>');
        html.push(      octoUtil.escapeHtml(matrix.heading));
        html.push(    '</th>');
        _.each(matrix.environments, function (env) {
            html.push('<th>');
            html.push(  '<a href="#/environments">');
            html.push(    octoUtil.escapeHtml(env.Name));
            html.push(  '</a>');
            matrix.renderGroupDeployButton(env, html);
            html.push('</th>');
        });
        html.push(    '<th style="width: auto"></th>');
        html.push(  '</tr>');
        html.push('</thead>');
    };

    var getPromotion = function (key, envId) {
        if (matrix.promotions) {
            var promotion = matrix.promotions[key];
            if (promotion) {
                return promotion;
            }
        }
    };

    var renderRows = function(html) {
        var rows = matrix.rows;
        if (!rows || rows.length === 0) {
            matrix.renderEmptyRow(html);
        }

        _.each(rows, function (row) {
            html.push('<tr>');
            html.push(  '<th class="relative">');
            matrix.renderRowHeading(row, html);
            html.push(  '</th>');
            _.each(matrix.environments, function(col) {
                var key = matrix.keyFromPair(col, row);
                html.push('<td id="');
                html.push(key);
                html.push('"');
                html.push('>');

                var items = matrix.items[key];
                var promotion = getPromotion(key, col.Id) || (!row.Id && matrix.promoteTo && _.find(matrix.promoteTo, function (env) { return env.Id === col.Id; }));
                renderTile(key, items, html, promotion, row, col);

                html.push('</td>');
            });
            html.push('<td class="last"></td>');
            html.push('</tr>');
        });
    };

    var getItemToShowOnDashboard = function (deployments) {
        if (!deployments || !deployments[0]) {
            return deployments;
        }
        var sortedDeployments = _.sortBy(deployments, 'ReleaseVersion').reverse();
        var index = _.findIndex(sortedDeployments, function (item) {
            return item.State === 'Executing' || 
                item.State === 'Failed' || 
                (item.State === 'Success' && item.HasWarningsOrErrors);
        });
        if (index > -1) {
            return sortedDeployments[index];
        }
        return sortedDeployments[0];
    };

    var getCompletedItemsCount = function (currentItem, items, tenantsLinked) {
        return _.filter(items, function (item) {
            return tenantsLinked.indexOf(item.TenantId) !== -1 &&
                item.State === 'Success' &&
                item.ReleaseId === currentItem.ReleaseId;
        }).length;
    };

    function getTileLink(matrix, item, hasTenants) {
        if (matrix.slice && matrix.slice.projects && !!hasTenants) {
            var project = _.find(matrix.slice.projects, function (a) {
                return a.Id === item.ProjectId;
            });
            return '#/projects/' + project.Slug +'?release='+ item.ReleaseVersion;
        } else {
            return '#/tasks/' + item.TaskId;
        }
    }

    var renderTile = function(key, items, html, promotion, row, col) {
        if (!items) {
            matrix.renderEmptyCell(key, html, promotion, row, col);
            return;
        }
        var item = getItemToShowOnDashboard(items);
        var releaseDate = moment(item.QueueTime);
        var tenantsLinked = matrix.projectEnvironmentTenantIndex[key];
        var hasTenants = !!tenantsLinked && tenantsLinked.length > 1;
        html.push('<a class="deployment-square" href="');
        html.push(getTileLink(matrix, item, hasTenants));
        html.push('">');
        taskStatusRenderer.render(html, item);
        if (hasTenants) {
            html.push('<div class="wrapper">');
        }
        html.push('<span class="deployment-square-info">');
        html.push(  '<span class="version">');
        html.push('    <span class="release-number" title="');
        html.push(octoUtil.escapeHtml(item.ReleaseVersion));
        html.push('">');
        html.push(octoUtil.escapeHtml(item.ReleaseVersion));
        html.push('    </span>');
        html.push('  </span>');
        html.push('  </span>');
        if (hasTenants) {
            var completedItems = getCompletedItemsCount(item, items, tenantsLinked);
            html.push('    <span class="label tenant-count">');
            html.push('<span class="progress-count">');
            html.push(completedItems);
            html.push('</span>');
            html.push('<span class="total-count">');
            html.push('/');
            html.push(tenantsLinked.length);
            html.push('</span>');
            html.push('    </span>');
        }
        if (hasTenants) { html.push('</div> ');}
        html.push(' <span class="release-date" title="');
        html.push(octoUtil.escapeHtml(releaseDate.format('LLLL')));
        html.push('">');
        html.push(octoUtil.escapeHtml(releaseDate.format('MMMM Do YYYY')));
        html.push('</span>');
        html.push('</span>');
        html.push('</a>');
    };

    var partialRender = function() {
        _.each(matrix.environments, function(env) {
            _.each(matrix.rows, function(row) {
                var key = matrix.keyFromPair(env, row);
                var promotion = getPromotion(key, env.Id) || (!row.Id && matrix.promoteTo && _.find(matrix.promoteTo, function (environment) { return environment.Id === env.Id; }));
                var oldItem = previousItems[key];
                var newItem = matrix.items[key];
                if (itemHasChanged(oldItem, newItem)) {
                    updateTile(key, newItem, $("#" + key, element), promotion);
                }
            });
        });
    };

    var updateTile = function(key, item, domElement, promotion) {
        var updatedItem = getItemToShowOnDashboard(item);
        var anchor = $("a.deployment-square", domElement);
        if (anchor.length === 0) {
            var html = [];
            renderTile(key, updatedItem, html);
            domElement.html(html.join(""));
        }

        anchor = $("a.deployment-square", domElement);
        if (anchor.length === 0) {
            return;
        }

        if (!item) {
            domElement.empty();
        } else {
            var releaseDate = moment(updatedItem.QueueTime);
            var tenantsLinked = matrix.projectEnvironmentTenantIndex[key] || [];
            var hasTenants = !!tenantsLinked && tenantsLinked.length > 1;
            anchor.attr("href", getTileLink(matrix, item[0], hasTenants));
            $(".version .release-number", anchor).text(updatedItem.ReleaseVersion);
            if (hasTenants) {
                var completedItems = getCompletedItemsCount(updatedItem, item, tenantsLinked);
                $(".version .tenant-count .progress-count", anchor).text(completedItems);
                $(".version .tenant-count .total-count", anchor).text('/' + tenantsLinked.length);
            }
            $(".release-date", anchor).attr("title", releaseDate.format('LLLL'));
            $(".release-date", anchor).text(releaseDate.format('MMMM Do YYYY'));
            taskStatusRenderer.update(updatedItem, $(".status", anchor));
        }
    };

    var compareValues = function(oldValue, newValue) {
        return angular.toJson(oldValue) !== angular.toJson(newValue);
    };

    var itemHasChanged = function(oldItem, newItem) {
        if (!oldItem && newItem) {
            // There wasn't a deployment here previously, and now there is
            return true;
        }

        if (oldItem && !newItem) {
            // There wasn't a deployment here previously, and now there is
            return true;
        }

        if (!oldItem && !newItem) {
            // Nothing to do
            return false;
        }

        if (!oldItem[0] && newItem[0]) {
            newItem = newItem[0];
        }
        
        if (oldItem[0] && !newItem[0]) {
            oldItem = oldItem[0];
        }

        if (oldItem[0] && newItem[0]) {
            if (oldItem.length !== newItem.length) {
                return true;
            }

            var oldItemStates = _.countBy(oldItem, function (item) { return item.State; });
            var newItemStates = _.countBy(newItem, function (item) { return item.State; });
            if (compareValues(oldItemStates, newItemStates)) {
                return true;
            }

            var oldItemReleaseVersions = _.countBy(oldItem, function (item) { return item.ReleaseVersion; });
            var newItemReleaseVersions = _.countBy(newItem, function (item) { return item.ReleaseVersion; });
            if (compareValues(oldItemReleaseVersions, newItemReleaseVersions)) {
                return true;
            }
        }

        if (oldItem.State !== newItem.State) {
            // Any changes to a task's state (queued -> failed)
            return true;
        }

        if (oldItem.State === "Executing" || oldItem.State === "Queued" || oldItem.State === "Paused") {
            // 'Running' tasks show durations, so we should always update them
            return true;
        }

        // The task has been replaced by another task
        return oldItem.Id !== newItem.Id;
    };
};



//////////////////
// WEBPACK FOOTER
// ./app/areas/dashboard/directives/release_matrix.js
// module id = 6095126918266213
// module chunks = 1